$(document).on('submit', '.js-form-prevent-empty-fields', (e) => {
    const controls = e.currentTarget.elements;

    for (let i = 0; i < controls.length; i++) {
        controls[i].disabled = controls[i].value === '';
    }
})